module.exports = __webpack_public_path__ + "img/how-02.c2c0b7f9.svg";